/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cap_6_TitleInputs */

const en_mk_cap_6_title = /** @type {(inputs: Mk_Cap_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costs you can see`)
};

const id_mk_cap_6_title = /** @type {(inputs: Mk_Cap_6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya yang kelihatan`)
};

/**
* | output |
* | --- |
* | "Costs you can see" |
*
* @param {Mk_Cap_6_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cap_6_title = /** @type {((inputs?: Mk_Cap_6_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cap_6_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cap_6_title(inputs)
	return en_mk_cap_6_title(inputs)
});